module.exports = __webpack_public_path__ + "static/cleaner-d218f6933438504f8301a1a6efff5593.svg";